module.exports = __webpack_public_path__ + "img/arrow-up-left-square.35bdf9ad.svg";